import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showSection: 0,
  siteId: null,
  loader: true,
  siteAuditDetails: {
    url: '',
    _id: '',
    user_id: ''
  },
  siteAuditRefresh: false,
  websiteMonitoringDetails: {
    monitoring: null,
    monitoring_time: null,
    total_optimized: null,
    total_scanned: null,
    score: null,
    created_at: null,
    url: '',
    siteTransferInvitation: {
      invitationId: '',
      invitation_email: '',
      status: ''
    },
    aiVisibilityProgressing: null
  },
  deleteMainSite: false,
  siteDetailRefresh: false,
  fifthCardPdfCheck: false,
  fourthCardPdfCheck: false,
  pdfIconBase64: null,
  reAuditCheck: false,
  seoIssuesTitle: '',
  latestDate: '',
  sectionCount: null,
  pdfPreviewLoader: null,
  refreshTable: false,
  seoIssuesIndex: 0,
  siteStatus: false,
  isProgressCompleted: false,
  stopAuditLoader: false,
  individualRefreshTable: false,
  isGscConnected: false,
  restrictReAuditModal: false,
  compare: null,
  compareDate: 0,
  refreshSiteId: '',
  isOpenChangePlan: false,
  isFromSlider: false,
  seoTaskDetails: {},
  isMonitoringProcess: false,
  isStartAnimation: false,
  blogData: [],
  isBlogData: null,
  firstSeoTitle: null,
  remainingBlogCount: null,
  isCheckerLoading: null,
  isGscFromCheckerCount: null,
  submitButtonText: 'Submit',
  submitButtonColor: null,
  bgColor: null,
  isLeadForm: false,
  userLeadId: null,
  refreshLeadTable: null,
  isIndexedCheck: null,
  isCheckerCount: null,
  userDateFormat: '',
  isAddScanSuccess: false,
  userSignUpDetails: [],
  indexingInProgress: null,
  openReAuditModal: false,
  openSnackBar: false,
  orbitAISnackBar: null as { status: string; message: string } | null,
  squareSpaceCode: null,
  siteAuditSite: null,
  accountDetailLoader: null,
  monitoringTimelineDetails: null,
  auditSiteDetailes: null,
  stripeLoader: false,
  isTermsModal: null,
  selectedSeoTask: null,
  seoTaskVideoDetail: null,
  selectedSeoTaskTabChanged: null,
  isExternalData: null,
  planUpgradeStatus: null,
  isGSCDisconnected: false,
  disconnectedGSCSiteId: '',
  isShowRedirectBanner: false,
  auditSiteDetails: [],
  isMultipleDelete: false,
  progressLoader: false,
  aiSelectedTaskDetails: null,
  auditCheckerDetails: null,
  pdfDrCount: null,
  pdfAiMainVisibilityDetails: null,
  isSiteSoftDeleted: false
};

/**
 * Redux slice for managing counter-related state.
 *
 * @name siteAuditSlice
 * @type {Slice}
 */
// Action functions declaration
export const siteAuditSlice = createSlice({
  name: 'siteAudit',
  initialState,
  reducers: {
    /**
     * Set the details of all sites.
     *
     * @function
     * @name setShowSection
     * @param {Object} state - The current state.
     * @param {Object} actions - The action with payload.
     */
    setShowSection: (state, actions) => {
      state.showSection = actions.payload;
    },
    setSiteId: (state, action) => {
      // Add a new reducer to set itemId
      state.siteId = action.payload;
    },
    setLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.loader = action.payload;
    },
    setSiteAuditDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.siteAuditDetails = action.payload;
    },
    setSiteAuditRefresh: (state, action) => {
      state.siteAuditRefresh = action.payload;
    },
    setWebsiteMonitoringDetails: (state, action) => {
      if (action.payload === null) {
        state.websiteMonitoringDetails = {
          monitoring: null,
          monitoring_time: null,
          total_optimized: null,
          total_scanned: null,
          score: null,
          created_at: null,
          url: '',
          siteTransferInvitation: {
            invitationId: '',
            invitation_email: '',
            status: ''
          },
          aiVisibilityProgressing: null
        };
      } else {
        state.websiteMonitoringDetails = {
          ...state.websiteMonitoringDetails, // keep existing values
          ...action.payload // update / overwrite only keys passed
        };
      }
    },

    setDeleteMainSite: (state, action) => {
      // Add a new reducer to set itemId
      state.deleteMainSite = action.payload;
    },
    setSiteDetailRefresh: (state, action) => {
      // Add a new reducer to set itemId
      state.siteDetailRefresh = action.payload;
    },
    setFifthCardPdfCheck: (state, action) => {
      // Add a new reducer to set itemId
      state.fifthCardPdfCheck = action.payload;
    },
    setFourthCardPdfCheck: (state, action) => {
      // Add a new reducer to set itemId
      state.fourthCardPdfCheck = action.payload;
    },
    setPdfIconBase64: (state, action) => {
      // Add a new reducer to set itemId
      state.pdfIconBase64 = action.payload;
    },
    setReAuditCheck: (state, action) => {
      // Add a new reducer to set itemId
      state.reAuditCheck = action.payload;
    },
    setSeoIssuesTitle: (state, action) => {
      // Add a new reducer to set itemId
      state.seoIssuesTitle = action.payload;
    },
    setLatestDate: (state, action) => {
      // Add a new reducer to set itemId
      state.latestDate = action.payload;
    },
    setSectionCount: (state, action) => {
      // Add a new reducer to set itemId
      state.sectionCount = action.payload;
    },
    setPdfPreviewLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.pdfPreviewLoader = action.payload;
    },
    setRefreshTable: (state, action) => {
      // Add a new reducer to set itemId
      state.refreshTable = action.payload;
    },
    setSeoIssuesIndex: (state, action) => {
      // Add a new reducer to set itemId
      state.seoIssuesIndex = action.payload;
    },
    setSiteStatus: (state, action) => {
      // Add a new reducer to set itemId
      state.siteStatus = action.payload;
    },
    setIsProgressCompleted: (state, action) => {
      // Add a new reducer to set itemId
      state.isProgressCompleted = action.payload;
    },
    setStopAuditLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.stopAuditLoader = action.payload;
    },
    setIndividualRefreshTable: (state, action) => {
      // Add a new reducer to set itemId
      state.individualRefreshTable = action.payload;
    },
    setIsGscConnected: (state, action) => {
      // Add a new reducer to set itemId
      state.isGscConnected = action.payload;
    },
    setRestrictReAuditModal: (state, action) => {
      // Add a new reducer to set itemId
      state.restrictReAuditModal = action.payload;
    },
    setCompare: (state, action) => {
      // Add a new reducer to set itemId
      state.compare = action.payload;
    },
    setCompareDate: (state, action) => {
      // Add a new reducer to set itemId
      state.compareDate = action.payload;
    },
    setRefreshSiteId: (state, action) => {
      // Add a new reducer to set itemId
      state.refreshSiteId = action.payload;
    },
    setIsOpenChangePlan: (state, action) => {
      // Add a new reducer to set itemId
      state.isOpenChangePlan = action.payload;
    },
    setIsFromSlider: (state, action) => {
      // Add a new reducer to set itemId
      state.isFromSlider = action.payload;
    },
    setSeoTaskDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.seoTaskDetails = action.payload;
    },
    setIsMonitoringProcess: (state, action) => {
      // Add a new reducer to set itemId
      state.isMonitoringProcess = action.payload;
    },
    setIsStartAnimation: (state, action) => {
      // Add a new reducer to set itemId
      state.isStartAnimation = action.payload;
    },
    setBlogData: (state, action) => {
      // Add a new reducer to set itemId
      state.blogData = action.payload;
    },
    setIsBlogData: (state, action) => {
      // Add a new reducer to set itemId
      state.isBlogData = action.payload;
    },
    setFirstSeoTitle: (state, action) => {
      // Add a new reducer to set itemId
      state.firstSeoTitle = action.payload;
    },
    setRemainingBlogCount: (state, action) => {
      // Add a new reducer to set itemId
      state.remainingBlogCount = action.payload;
    },
    setIsCheckerLoading: (state, action) => {
      // Add a new reducer to set itemId
      state.isCheckerLoading = action.payload;
    },
    setIsGscFromCheckerCount: (state, action) => {
      // Add a new reducer to set itemId
      state.isGscFromCheckerCount = action.payload;
    },
    setTheSubmitButtonText: (state, action) => {
      // Add a new reducer to set itemId
      state.submitButtonText = action.payload;
    },
    setTheSubmitButtonColor: (state, action) => {
      // Add a new reducer to set itemId
      state.submitButtonColor = action.payload;
    },
    setTheBgColor: (state, action) => {
      // Add a new reducer to set itemId
      state.bgColor = action.payload;
    },
    setIsLeadForm: (state, action) => {
      // Add a new reducer to set itemId
      state.isLeadForm = action.payload;
    },
    setUserLeadId: (state, action) => {
      // Add a new reducer to set itemId
      state.userLeadId = action.payload;
    },
    setRefreshLeadTable: (state, action) => {
      // Add a new reducer to set itemId
      state.refreshLeadTable = action.payload;
    },
    setIsIndexedCheck: (state, action) => {
      // Add a new reducer to set itemId
      state.isIndexedCheck = action.payload;
    },
    setIsCheckerCount: (state, action) => {
      // Add a new reducer to set itemId
      state.isCheckerCount = action.payload;
    },
    setUserDateFormat: (state, action) => {
      // Add a new reducer to set itemId
      state.userDateFormat = action.payload;
    },
    setIsAddScanSuccess: (state, action) => {
      // Add a new reducer to set itemId
      state.isAddScanSuccess = action.payload;
    },
    setUserSignUpDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.userSignUpDetails = action.payload;
    },
    setIndexingInProgress: (state, action) => {
      // Add a new reducer to set itemId
      state.indexingInProgress = action.payload;
    },
    setOpenReAuditModal: (state, action) => {
      // Add a new reducer to set itemId
      state.openReAuditModal = action.payload;
    },
    setOpenSnackBar: (state, action) => {
      // Add a new reducer to set itemId
      state.openSnackBar = action.payload;
    },
    setOrbitAISnackBar: (state, action) => {
      state.orbitAISnackBar = action.payload;
    },

    setSquareSpaceCode: (state, action) => {
      // Add a new reducer to set itemId
      state.squareSpaceCode = action.payload;
    },

    setSiteAuditSite: (state, action) => {
      // Add a new reducer to set itemId
      state.siteAuditSite = action.payload;
    },
    setAccountDetailLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.accountDetailLoader = action.payload;
    },
    setMonitoringTimelineDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.monitoringTimelineDetails = action.payload;
    },
    setAuditSiteReduxDetailes: (state, action) => {
      // Add a new reducer to set itemId
      state.auditSiteDetailes = action.payload;
    },
    setStripeLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.stripeLoader = action.payload;
    },
    setTermModal: (state, action) => {
      // Add a new reducer to set itemId
      state.isTermsModal = action.payload;
    },
    setSelectedSeoTask: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedSeoTask = action.payload;
    },
    setSeoTaskVideoDetail: (state, action) => {
      // Add a new reducer to set itemId
      state.seoTaskVideoDetail = action.payload;
    },
    setSelectedSeoTaskTabChanged: (state, action) => {
      // Add a new reducer to set itemId
      state.selectedSeoTaskTabChanged = action.payload;
    },
    setIsExternalData: (state, action) => {
      // Add a new reducer to set itemId
      state.isExternalData = action.payload;
    },
    setIsPlanUpgradeStatus: (state, action) => {
      // Add a new reducer to set itemId
      state.planUpgradeStatus = action.payload;
    },
    setIsGSCDisconnected: (state, action) => {
      // Add a new reducer to set itemId
      state.isGSCDisconnected = action.payload.isGSCDisconnected;
      state.disconnectedGSCSiteId = action.payload.siteId;
    },
    setIsShowRedirectBanner: (state, action) => {
      // Add a new reducer to set itemId
      state.isShowRedirectBanner = action.payload;
    },
    setAuditSiteDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.auditSiteDetails = action.payload;
    },
    setIsMultipleDelete: (state, action) => {
      // Add a new reducer to set itemId
      state.isMultipleDelete = action.payload;
    },
    setProgressLoader: (state, action) => {
      // Add a new reducer to set itemId
      state.progressLoader = action.payload;
    },
    setAISelectedTaskDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.aiSelectedTaskDetails = action.payload;
    },
    setAuditCheckerDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.auditCheckerDetails = action.payload;
    },
    setPdfDrCount: (state, action) => {
      // Add a new reducer to set itemId
      state.pdfDrCount = action.payload;
    },
    setPdfAiMainVisibilityDetails: (state, action) => {
      // Add a new reducer to set itemId
      state.pdfAiMainVisibilityDetails = action.payload;
    },
    setIsSiteSoftDeleted: (state, action) => {
      // Add a new reducer to set itemId
      state.isSiteSoftDeleted = action.payload;
    },

    siteAuditCleanupInitialState: () => initialState
  }
});

// Action creators are generated for each case reducer function
export const {
  setShowSection,
  setSiteId,
  setLoader,
  setSiteAuditDetails,
  siteAuditCleanupInitialState,
  setSiteAuditRefresh,
  setWebsiteMonitoringDetails,
  setDeleteMainSite,
  setSiteDetailRefresh,
  setFifthCardPdfCheck,
  setFourthCardPdfCheck,
  setPdfIconBase64,
  setReAuditCheck,
  setSeoIssuesTitle,
  setLatestDate,
  setSectionCount,
  setPdfPreviewLoader,
  setRefreshTable,
  setSeoIssuesIndex,
  setSiteStatus,
  setIsProgressCompleted,
  setStopAuditLoader,
  setIndividualRefreshTable,
  setIsGscConnected,
  setRestrictReAuditModal,
  setCompare,
  setCompareDate,
  setRefreshSiteId,
  setIsOpenChangePlan,
  setIsFromSlider,
  setSeoTaskDetails,
  setIsMonitoringProcess,
  setIsStartAnimation,
  setBlogData,
  setIsBlogData,
  setFirstSeoTitle,
  setRemainingBlogCount,
  setIsCheckerLoading,
  setIsGscFromCheckerCount,
  setTheSubmitButtonText,
  setTheSubmitButtonColor,
  setTheBgColor,
  setIsLeadForm,
  setUserLeadId,
  setRefreshLeadTable,
  setIsIndexedCheck,
  setIsCheckerCount,
  setIsAddScanSuccess,
  setUserSignUpDetails,
  setIndexingInProgress,
  setOpenReAuditModal,
  setOpenSnackBar,
  setOrbitAISnackBar,
  setSquareSpaceCode,
  setSiteAuditSite,
  setAccountDetailLoader,
  setMonitoringTimelineDetails,
  setAuditSiteReduxDetailes,
  setStripeLoader,
  setTermModal,
  setSelectedSeoTask,
  setSeoTaskVideoDetail,
  setSelectedSeoTaskTabChanged,
  setIsExternalData,
  setIsPlanUpgradeStatus,
  setIsGSCDisconnected,
  setIsShowRedirectBanner,
  setAuditSiteDetails,
  setIsMultipleDelete,
  setProgressLoader,
  setAISelectedTaskDetails,
  setAuditCheckerDetails,
  setPdfDrCount,
  setPdfAiMainVisibilityDetails,
  setIsSiteSoftDeleted
} = siteAuditSlice.actions;

export default siteAuditSlice.reducer;
